import { Facility, Partner } from '@medprev-web-app/api-graphql-client';

import { mapSearchApiRating } from '@/app/(main)/(pages)/_services/search-api/map-search-api-rating.util';
import {
  SearchApiFacility,
  SearchApiPartner,
  SearchApiRating,
} from '@/app/(main)/(pages)/_types/search-api-response.type';

function mapFacility(facility: SearchApiFacility, rating: SearchApiRating | null): Facility {
  return {
    id: facility.id,
    name: facility.name ?? null,
    slug: facility.slug ?? null,
    type: facility.type ?? null,
    city: facility.city ?? null,
    state: facility.state ?? null,
    neighborhood: facility.neighborhood ?? null,
    zipcode: facility.zipcode ?? null,
    addressLine1: facility.addressLine1 ?? null,
    addressLine2: facility.addressLine2 ?? null,
    number: facility.number ?? null,
    contacts: {
      email: facility.contacts?.email ?? null,
      phones: facility.contacts?.phones ?? [],
      whatsapp: facility.contacts?.whatsapp ?? null,
    },
    structure: {
      airConditioning: facility.structure?.airConditioning ?? false,
      elevator: facility.structure?.elevator ?? false,
      parking: facility.structure?.parking ?? false,
      specialAccess: facility.structure?.specialAccess ?? false,
    },
    rating: mapSearchApiRating(rating),
  };
}

export function mapSearchApiPartner(
  facility: SearchApiFacility,
  partner: SearchApiPartner | null,
  rating: SearchApiRating | null,
): Partner {
  const socialName = partner?.socialName ?? facility.partner?.socialName ?? '';

  return {
    id: partner?.id ?? facility.partnerId ?? facility.partner?.id ?? '',
    slug: facility.slug ?? null,
    socialName,
    legalName: partner?.legalName ?? socialName,
    type: partner?.type ?? facility.partner?.type ?? null,
    avatar: partner?.avatar ?? facility.partner?.avatar ?? null,
    avatarLarge: partner?.avatarLarge ?? null,
    description: facility.description ?? partner?.description ?? null,
    followUp: null,
    distance: null,
    specialties: (partner?.specialties ?? []).map((specialty) => specialty.name),
    availableServiceChannels: partner?.availableServiceChannels ?? [],
    facilities: [mapFacility(facility, rating)],
    facilityImages: (facility.images ?? []).map((image) => ({
      id: image.id ?? null,
      name: image.name ?? null,
      src: image.src ?? null,
    })),
  };
}
